<script lang="ts">
  import { onMount } from "svelte";
  import SearchHeader from "../../../components/SearchHeader.svelte";
  import { Table } from "../../../components/Table";
  import QualityLayout from "../../../layout/QualityLayout.svelte";
  import { filter, loading, records, pagination, initList, onCreate, onEdit, onDelete, onPageChange, search, downloadQualityWasteReport } from "./quality-waste.store";
  import { qualityWasteFields } from "../../../utils/TableFields/quality-waste.fields";
  import Button from "../../../components/Button.svelte";
  import Icon from "../../../components/Icon.svelte";
  import NumberInput from "../../../components/Form/Fields/NumberInput.svelte";

  onMount(initList);
</script>

<QualityLayout>
  <SearchHeader
    entitySingular="smaltimento"
    entityPlural="smaltimenti"
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
		searchFieldVisible={false}
    on:search={search}
		>
		<div slot="search" class="level-item">
      <div style="min-width: 5rem;">
				<NumberInput name="" placeholder="anno" bind:value={$filter.criteria.year} />
      </div>
			<p class="control" style="margin-left:1rem;">
				<Button on:click={search}>
					<Icon name="search" />
					<span> Cerca </span>
				</Button>
			</p>

      <p class="control" style="margin-left:1rem;">
        <Button klass="is-clear" on:click={downloadQualityWasteReport}>
          <span>Stampa riepilogo annuale</span>
        </Button>
      </p>
		</div>
	</SearchHeader>

  <Table
    loading={$loading}
    fields={qualityWasteFields}
    records={$records}
    pagination={$pagination}
    createEnabled={true}
    editEnabled={true}
    deleteEnabled={true}
    on:create={(_) => onCreate()}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</QualityLayout>
